import PortfolioPageLayout from "../PortfolioPageLayout";
  import parralilyData from "./parralilyData";

  function Parralily() {
    return <PortfolioPageLayout {...parralilyData} />;
}

export default Parralily;
